export const statuses = {
  NEW: "1-05-new",
  MALWARE_AND_SECURITY: "1-04-malware-and-security",
  CLIENT_REPLIED: "1-04-client-replied",
  WEBSITE_TWEAKS: "1-03-website-tweaks",
  IN_PROGRESS: "1-03-in-progress",
  ON_HOLD: "1-02-on-hold",
  WAITING_FOR_REPLY: "1-01-waiting-for-reply",
  SCHEDULED: "1-00-scheduled",
  QUEUED: "1-00-queued",
  COMPLETE: "0-01-complete",
  CANCELLED: "0-01-cancelled",
  DELETED: "0-00-deleted"
};

export const teams = {
  MAINTENANCE: { key: "maintenance", label: "Maintenance" }
};

export const priorities = {
  GENERAL: "0-general",
  ADVANCED: "1-advanced",
  HIGH: "2-high"
};

export function getPriorityIcon(priority) {
  switch (priority) {
    case priorities.HIGH:
      return {
        icon: "fire",
        type: "is-danger",
        size: "is-small",
        title: "High priority task"
      };
    case priorities.ADVANCED:
      return {
        icon: "flask",
        type: "is-dark",
        size: "is-small",
        title: "Complex task"
      };
    default:
      return null;
  }
}

/* Time (ms) from a task being raised to the first reply from any agent, or
`null` where there isn't a meaningful response time: no agent has replied yet,
the task was scheduled (so wasn't due to be picked up when raised), or it was
raised by an agent – their opening post is recorded as the first agent reply, so
the two dates match (give or take rounding, hence the one second floor). */
export function getFirstResponseTime(task) {
  const firstReply = task.stats && task.stats.dateOfAgentFirstReply;
  if (!firstReply || !task.dateCreated || task.dateScheduled) return null;
  const responseTime = firstReply.toMillis() - task.dateCreated.toMillis();
  return responseTime >= 1000 ? responseTime : null;
}

/* Formats a duration (ms) compactly, eg. "45s", "12m", "3h 5m" or "2d 4h". */
export function formatDuration(ms) {
  const minutes = Math.floor(ms / 60000);
  if (minutes < 1) return `${Math.floor(ms / 1000)}s`;
  if (minutes < 60) return `${minutes}m`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24)
    return minutes % 60 ? `${hours}h ${minutes % 60}m` : `${hours}h`;
  const days = Math.floor(hours / 24);
  return hours % 24 ? `${days}d ${hours % 24}h` : `${days}d`;
}
